module.exports = __webpack_public_path__ + "media/icons/spinner-59d6f4a6.svg";